import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"],
  _excluded2 = ["as", "events", "children", "data", "asChild"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { DATA_METRIC_DATA, DATA_METRIC_MODE, DATA_METRIC_NAME, DATA_METRIC_ONCE, DATA_METRIC_THRESHOLD } from "./consts";
import { convertEventsConfig } from "./utils/fireEvents";
var Slot = function Slot(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  if ( /*#__PURE__*/React.isValidElement(children)) {
    return /*#__PURE__*/React.cloneElement(children, _objectSpread(_objectSpread({}, props), children.props));
  }
  if (React.Children.count(children) > 1) {
    React.Children.only(null);
  }
  return null;
};
export var Metric = function Metric(_ref2) {
  var _commonProps, _ref3;
  var _ref2$as = _ref2.as,
    as = _ref2$as === void 0 ? 'div' : _ref2$as,
    events = _ref2.events,
    children = _ref2.children,
    data = _ref2.data,
    asChild = _ref2.asChild,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var Wrapper = asChild ? Slot : as;
  var metricName = convertEventsConfig(events);
  var commonProps = (_commonProps = {}, _defineProperty(_commonProps, DATA_METRIC_NAME, metricName), _defineProperty(_commonProps, DATA_METRIC_MODE, props.mode), _defineProperty(_commonProps, DATA_METRIC_DATA, data), _commonProps);
  var viewportProps = props.mode === 'viewport' ? (_ref3 = {}, _defineProperty(_ref3, DATA_METRIC_THRESHOLD, props.threshold || 1), _defineProperty(_ref3, DATA_METRIC_ONCE, props.once || false), _ref3) : {};
  var childrenProps = {
    dataMetricAttrs: _objectSpread(_objectSpread({}, commonProps), viewportProps)
  };
  return typeof children === 'function' ? children(childrenProps) : /*#__PURE__*/React.createElement(Wrapper, childrenProps.dataMetricAttrs, children);
};